/* istanbul ignore file */

import { mainApi } from "config/api";
import { getClientFor } from "infrastructure/http";
import { ITerm } from "ui/screens/plex-dictionary/term-translations";

import { IMessage } from "../message-relationships/MessageRelationships.state";

const buildRequestConfig = (version: number) => ({
  headers: {
    "If-Match": `${version}`
  }
});

export const getMessageDetails = async (messageId: string) => (await getClientFor(mainApi.name).get<IMessage>(`/messages/${messageId}`)).data;
export const getAllTerms = async (filter: string) => (await getClientFor(mainApi.name).get<ITerm[]>(`/terms`, { params: filter })).data;
export const getAssociatedTerms = async (messageId: string) => (await getClientFor(mainApi.name).get<ITerm[]>(`/messages/${messageId}/related-terms`)).data;
export const addAssociatedTerm = async (messageId: string, termId: string, version: number) =>
  await getClientFor(mainApi.name).post(`/messages/${messageId}/related-terms/${termId}`, null, buildRequestConfig(version));
export const deleteAssociatedTerm = async (messageId: string, termId: string, version: number) =>
  await getClientFor(mainApi.name).delete(`/messages/${messageId}/related-terms/${termId}`, buildRequestConfig(version));
